import { ShareIcon } from '@cdl/heartbeat-react';
import { useHolterStripUrl } from '../hooks/use-holter-strip-url';
import { ToolButton } from '../../../features/tool/components/ToolButton';

export const OpenInNewLink: React.FC = () => {
  const url = useHolterStripUrl();

  return (
    <ToolButton
      label='View Parent Holter'
      href={url}
      aria-label='View Parent Holter'
      icon={<ShareIcon />}
    />
  );
};
